import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { addUnOpenSurvey, getUnOpenSurvey, setShowCycle, setSubmitCycle, checkTriggerWay, checkoutFrequency, addShowsFrequency, getShowsFrequency, analysisBehaviorFrequency, getBehaviorFrequency, openDisabled, checkMatchHref, _getStorage, _setStorage, clearStorage, XdomainStorageKeys, initXdomainStorage } from './utils';
import { del, set } from './indexdb';
import { TRIGGER_WAY, ASSOCIATETYPE, TRIGGER_MOMENT, STATUS, SCHEMA_TYPE } from './api';
export default function getAESPluginSurveyCore(aes) {
  var surveyConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var log = function log(data) {
    aes.log('qnr', data);
  };
  var surveyList = [];
  var settings = {};
  var LOG_STORAGE = {};

  // 初始化 xdomainStorage，支持自定义 frame 域名
  var customFrameUrl = surveyConfig === null || surveyConfig === void 0 ? void 0 : surveyConfig.customFrameUrl;
  initXdomainStorage(customFrameUrl);

  // 获取单个插件数据
  var getSchema = function getSchema(options) {
    var id = options.id,
      _options$autoTrigger = options.autoTrigger,
      autoTrigger = _options$autoTrigger === void 0 ? false : _options$autoTrigger;
    return new Promise(function (resolve, reject) {
      // before: const { pid } = aes.getConfig() || {};
      // 兼容combo场景
      var config = aes.getConfig() || {};
      var pid = config.plugin_survey && config.plugin_survey.pid || config.pid;
      if (!pid) {
        reject(new Error('pid not found'));
      }
      var pidChanged = config.plugin_survey && config.plugin_survey.pidChanged;
      Promise.all([new Promise(function (r, j) {
        if (!surveyList || !surveyList.length || pidChanged) {
          // 获取列表数据
          var host = surveyConfig === null || surveyConfig === void 0 ? void 0 : surveyConfig.urlPrefix;
          var url = host ? "".concat(host, "api/open/").concat(pid, "/qnrForm?pageSize=1000") : "https://xux-web-config.oss-accelerate.aliyuncs.com/aes-config/".concat(pid, "/qnrForm.json");
          fetch(url).then(function (res) {
            return res.json();
          }).then(function (res) {
            if (!res.success) {
              console.error('[AES] plugin-survey', 'config file not found');
              return [];
            }
            var _res$data = res.data,
              data = _res$data === void 0 ? {} : _res$data,
              _res$content = res.content,
              content = _res$content === void 0 ? {} : _res$content;
            surveyList = data.rows || content.rows || [];
            settings = (res || {}).settings;
            return surveyList;
          }).then(function (list) {
            r(list);
          }).catch(function (error) {
            r([]);
          });
        } else {
          r(surveyList);
        }
      }), new Promise(function (r, j) {
        if (id && !autoTrigger) {
          r([]);
        } else {
          r(getUnOpenSurvey());
        }
      }), new Promise(function (r, j) {
        return r(getShowsFrequency());
      }), openDisabled(), getBehaviorFrequency()]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 5),
          surveyList = _ref2[0],
          unOpenIds = _ref2[1],
          showedList = _ref2[2],
          disabled = _ref2[3],
          behaviorList = _ref2[4];
        var openSurveySchema = null;
        var timer = 0;

        // 清除缓存中存在但是接口返回不包含的问卷
        clearStorage(surveyList, pid);
        surveyList.some(function (survey, index) {
          // 已经有符合打开条件的插件了，同一时间只打开一个插件
          if (openSurveySchema) {
            return false;
          }

          // 问卷下架
          if (survey.status == STATUS.CLOSE) {
            return false;
          }

          // 方法调用方式 脚本触发，不是对应id
          if (!!id && id != survey.id) {
            return false;
          }

          // 方法调用方式 脚本触发，是对应id
          if (!!id && id == survey.id) {
            if (!disabled && autoTrigger && !unOpenIds.find(function (x) {
              return x == survey.id;
            }) && !checkoutFrequency(settings, survey.id, showedList) || !autoTrigger) {
              // 非无痕模式下 启用疲劳控制，且通过了
              // 不启用疲劳控制，直接返回，无痕模式下也可返回打开
              openSurveySchema = _objectSpread(_objectSpread({}, survey.formSchema), {}, {
                id: survey.id,
                hide: false
              });
            }
            return true;
          }

          // 自动触发模式下，无痕模式/缓存写入失败不触发插件
          if (disabled) {
            return false;
          }
          var triggerSetting = survey.formSchema && survey.formSchema.triggerSetting || {};
          var schema = survey.formSchema && survey.formSchema.schema || {};
          var seconds = triggerSetting.seconds || {};
          var _triggerSetting$trigg = triggerSetting.triggerBehavior,
            triggerBehavior = _triggerSetting$trigg === void 0 ? {} : _triggerSetting$trigg,
            triggerWay = triggerSetting.triggerWay;
          if (triggerBehavior.type == '1' && triggerWay == TRIGGER_WAY.CUSTOMIZED && behaviorList.find(function (x) {
            return x.surveyId == survey.id;
          })) {
            // 行为触发不打开
            return false;
          }

          // 触发方式、触发页面
          if (!checkTriggerWay(triggerSetting, {
            behaviorType: triggerBehavior.type,
            behaviorData: triggerBehavior.data
          })) {
            return false;
          }

          // 判断疲劳
          if (unOpenIds.find(function (x) {
            return x == survey.id;
          })) {
            // 在缓存中存在
            return false;
          }

          // 最后一个判断，通过了则可以返回 // 判断立即展示
          if (triggerSetting.triggerMoment === TRIGGER_MOMENT.ON_LOAD || triggerSetting.triggerMoment === TRIGGER_MOMENT.AFTER_LOAD || triggerSetting.triggerMoment === TRIGGER_MOMENT.ON_CLICK && (schema.showType || schema.schemaType == SCHEMA_TYPE.WALLHANGING)) {
            // 页面加载完成后触发弹窗
            // 页面加载完成 x 秒后触发弹窗
            // 当点击悬浮按钮的时候触发
            openSurveySchema = _objectSpread(_objectSpread({}, survey.formSchema), {}, {
              id: survey.id,
              hide: false
            });
            if (triggerSetting.triggerMoment === TRIGGER_MOMENT.AFTER_LOAD) {
              timer = Number(seconds) * 1000 || 0;
            } else if (triggerSetting.triggerMoment === TRIGGER_MOMENT.ON_CLICK && (schema.showType || schema.schemaType == SCHEMA_TYPE.WALLHANGING)) {
              // 调用该方法隐藏弹窗，仅保留悬浮按钮
              openSurveySchema.hide = true;
            }
            // 多插件疲劳度控制
            if (checkoutFrequency(settings, survey.id, showedList)) {
              openSurveySchema = null;
              return false;
            }
            return true;
          } else if (triggerSetting.triggerMoment === TRIGGER_MOMENT.NOT_SHOW) {
            // 页面加载后不显示，什么也不做，留个占位
          }
          return false;
        });
        setTimeout(function () {
          resolve(openSurveySchema);
        }, timer);
      });
    });
  };

  // 获取插件列表数据
  var getSchemaList = function getSchemaList() {
    var config = aes.getConfig() || {};
    var pid = config.plugin_survey && config.plugin_survey.pid || config.pid;
    var pidChanged = config.plugin_survey && config.plugin_survey.pidChanged;
    return new Promise(function (resolve, reject) {
      if (surveyList && surveyList.length && !pidChanged) {
        // 清除缓存中存在但是接口返回不包含的问卷
        clearStorage(surveyList, pid);
        resolve(surveyList);
        return;
      }

      // 没有插件数据，那么发请求获取数据
      getSchema({}).then(function (res) {
        resolve(surveyList);
      });
    });
  };

  // 获取预览数据
  var getDraftSchema = function getDraftSchema(options) {
    var id = options.id;
    if (!id) {
      return Promise.resolve(null);
    }

    // before: const { pid } = aes.getConfig() || {};
    // 兼容combo场景
    var config = aes.getConfig() || {};
    var pid = config.plugin_survey && config.plugin_survey.pid || config.pid;
    if (!pid) {
      console.error('[AES] plugin-survey', 'config pid not found');
      return;
    }

    // 获取草稿数据
    var url = "https://xux-web-config.cn-hangzhou.oss.aliyuncs.com/aes-config/".concat(pid, "/qnrForm/").concat(id, "_draft.json");
    return fetch(url).then(function (res) {
      return res.json();
    }).then(function (res) {
      if (!res.success) {
        console.error('[AES] plugin-survey', 'draft config file not found');
        return [];
      }
      var _res$data2 = res.data,
        data = _res$data2 === void 0 ? {} : _res$data2,
        _res$content2 = res.content,
        content = _res$content2 === void 0 ? {} : _res$content2;
      return data.rows || content.rows || [];
    }).then(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 1),
        _ref4$ = _ref4[0],
        draftSurvey = _ref4$ === void 0 ? null : _ref4$;
      if (!draftSurvey || !draftSurvey.draftSchema) {
        return null;
      }
      return _objectSpread(_objectSpread({
        id: draftSurvey.id
      }, draftSurvey.draftSchema), {}, {
        hide: false
      });
    }).catch(function (error) {
      // console.log(error);
      return null;
    });
  };

  // utils 设置疲劳
  var setFrequency = function setFrequency(_ref5) {
    var id = _ref5.id,
      _ref5$type = _ref5.type,
      type = _ref5$type === void 0 ? 'nextMonth' : _ref5$type,
      _ref5$nextMonthShow = _ref5.nextMonthShow,
      nextMonthShow = _ref5$nextMonthShow === void 0 ? false : _ref5$nextMonthShow;
    var config = aes.getConfig() || {};
    var pid = config.plugin_survey && config.plugin_survey.pid || config.pid;
    var survey = surveyList.find(function (x) {
      return x.id == id;
    });
    if (!survey) {
      return;
    }
    var _ref6 = survey.formSchema || [],
      _ref6$triggerSetting = _ref6.triggerSetting,
      triggerSetting = _ref6$triggerSetting === void 0 ? {} : _ref6$triggerSetting;
    if (type === 'nextMonth' || nextMonthShow) {
      // 直接添加缓存，点击不再展示时
      addUnOpenSurvey(id, '30', pid);
    } else if (type === 'open') {
      // 更新本次问卷展示的时间
      addShowsFrequency(id, pid);
      setShowCycle(id, triggerSetting, pid);
      // 插件打开后，判断疲劳次数，疲劳频次周期
    } else if (type === 'submit') {
      // 插件提交后，判断疲劳配置
      setSubmitCycle(id, triggerSetting, pid);
    }
  };

  // utils 发送日志
  var sendLog = function sendLog(_ref7) {
    var id = _ref7.id,
      _ref7$content = _ref7.content,
      content = _ref7$content === void 0 ? [] : _ref7$content,
      _ref7$config = _ref7.config,
      config = _ref7$config === void 0 ? {} : _ref7$config,
      _ref7$type = _ref7.type,
      type = _ref7$type === void 0 ? 'expose' : _ref7$type,
      _ref7$currentVersion = _ref7.currentVersion,
      currentVersion = _ref7$currentVersion === void 0 ? null : _ref7$currentVersion;
    if (!type || !type.trim()) {
      console.error('[AES] plugin-survey', 'sendLog type can not be empty');
      return false;
    }
    if (!LOG_STORAGE[id] || type === 'expose') {
      // 不存在则定义一个
      // 存在且是曝光日志则刷新换一个
      LOG_STORAGE[id] = {
        time_stamps: Number((Math.random() * 1000 + 100).toFixed(0) + Date.now()).toString(16),
        first_answer: true
      };
    }
    var logData = {
      p1: 'form_view',
      p2: 'expose',
      p3: id,
      p4: LOG_STORAGE[id]['time_stamps']
    };
    config && (logData = Object.assign(logData, config));
    if (type === 'expose') {
      // 曝光日志
      log(_objectSpread(_objectSpread({}, logData), {}, {
        p10: currentVersion
      }));
    } else if (type === 'close') {
      // 关闭日志
      logData.p2 = 'close';
      log(logData);
    } else if (type === 'start_answer' && LOG_STORAGE[id] && LOG_STORAGE[id]['first_answer']) {
      logData.p2 = 'start_answer';
      log(logData);
      LOG_STORAGE[id]['first_answer'] = false;
    } else if (type === 'submit') {
      // 提交日志
      var showIds = setLogicRules(content) || [];
      content.filter(function (x) {
        return x && x.name !== 'title' && showIds.includes(x.id);
      }).forEach(function (item, index) {
        logData.p1 = item.name == 'tags' ? 'tag' : item.name == 'suggestion' ? 'feedback' : item.name;
        if (item.name == 'tags') {
          (item.score || []).filter(function (x) {
            return !!x;
          }).forEach(function (_ref8) {
            var value = _ref8.value;
            log(_objectSpread(_objectSpread({}, logData), {}, {
              p2: value,
              p5: item.id
            }));
          });
        } else if (item.score != null && item.score != undefined) {
          log(_objectSpread(_objectSpread({}, logData), {}, {
            p2: item.score,
            p5: item.id
          }));
        }
      });
    }

    // 日志发送完成后，是否要更新唯一值
    if (LOG_STORAGE[id] && type === 'close') {
      LOG_STORAGE[id] = {
        time_stamps: Number((Math.random() * 1000 + 100).toFixed(0) + Date.now()).toString(16),
        first_answer: true
      };
    }
    return true;
  };

  // utils 设置管理逻辑
  var setLogicRules = function setLogicRules(content) {
    var logicDetail = {};
    var show = true;
    return content.map(function (item) {
      show = true;
      try {
        item.logicRules && item.logicRules.length && item.logicRules.forEach(function (rule) {
          // 如果自身有逻辑关联，不满足条件
          logicDetail = rule || {};
          var _logicDetail = logicDetail,
            relyId = _logicDetail.relyId,
            associateType = _logicDetail.associateType,
            options = _logicDetail.options;
          var _ref9 = content.find(function (x) {
              return x.id == relyId;
            }) || {},
            score = _ref9.score,
            relyName = _ref9.name;
          show = false;
          if (['satisfaction', 'nps', 'ces', 'rating'].includes(relyName) && (associateType === ASSOCIATETYPE.INCLUDES && options.includes(score) || associateType === ASSOCIATETYPE.EQUAL && score == options[0] || associateType === ASSOCIATETYPE.NOTNULL && score)) {
            // 评分题 有逻辑关系，且之前到题目满足条件，显示
            show = true;
          } else if (relyName === 'tags') {
            // 标签题 有逻辑关系，且之前到题目满足条件，显示
            var tempScore = (score || []).map(function (x) {
              return x.index;
            });
            if (associateType === ASSOCIATETYPE.INCLUDES && options.findIndex(function (x) {
              return tempScore.includes(x);
            }) != -1 || associateType === ASSOCIATETYPE.EQUAL && score && score.length && options.length == score.length && options.every(function (x) {
              return tempScore.includes(x);
            }) || associateType === ASSOCIATETYPE.NOTNULL && score && score.length) {
              show = true;
            }
          }
          if (show === false) {
            throw '循环中止';
          }
        });
      } catch (e) {}
      return _objectSpread(_objectSpread({}, item), {}, {
        show: show
      });
    }).filter(function (x) {
      return x.show;
    }).map(function (x) {
      return x.id;
    });
  };
  var setRequireLogicRules = function setRequireLogicRules(content) {
    var requireRule = {};
    var required = false;
    var requires = content.map(function (item) {
      if (item.required !== "condition") {
        return _objectSpread(_objectSpread({}, item), {}, {
          required: item.required
        });
      }
      try {
        item.requiredRules && item.requiredRules.length && item.requiredRules.forEach(function (rule) {
          // 如果自身有逻辑关联，不满足条件
          requireRule = rule || {};
          var _requireRule = requireRule,
            relyId = _requireRule.relyId,
            associateType = _requireRule.associateType,
            options = _requireRule.options;
          var _ref10 = content.find(function (x) {
              return x.id == relyId;
            }) || {},
            score = _ref10.score,
            relyName = _ref10.name;
          required = false;
          if (['satisfaction', 'nps', 'ces', 'rating'].includes(relyName) && (associateType === ASSOCIATETYPE.INCLUDES && options.includes(score) || associateType === ASSOCIATETYPE.EQUAL && score == options[0] || associateType === ASSOCIATETYPE.NOTNULL && score)) {
            // 评分题 有逻辑关系，且之前到题目满足条件，显示
            required = true;
          } else if (relyName === 'tags') {
            // 标签题 有逻辑关系，且之前到题目满足条件，显示
            var tempScore = (score || []).map(function (x) {
              return x.index;
            });
            if (associateType === ASSOCIATETYPE.INCLUDES && options.findIndex(function (x) {
              return tempScore.includes(x);
            }) != -1 || associateType === ASSOCIATETYPE.EQUAL && score && score.length && options.length == score.length && options.every(function (x) {
              return tempScore.includes(x);
            }) || associateType === ASSOCIATETYPE.NOTNULL && score && score.length) {
              required = true;
            }
          }
        });
      } catch (e) {}
      return _objectSpread(_objectSpread({}, item), {}, {
        required: required
      });
    });
    return requires;
  };

  // utils 设置行为事件触发方式 疲劳
  var setBehaviorFrequency = function setBehaviorFrequency() {
    var config = aes.getConfig() || {};
    var pid = config.plugin_survey && config.plugin_survey.pid || config.pid;
    return new Promise(function (resolve, reject) {
      try {
        var behaviorFrequencyInfo = [];
        getSchemaList().then(function (list) {
          list.forEach(function (survey, index) {
            // 问卷下架
            if (survey.status == STATUS.CLOSE) {
              return false;
            }
            var triggerSetting = survey.formSchema && survey.formSchema.triggerSetting || {};
            var _triggerSetting$trigg2 = triggerSetting.triggerBehavior,
              triggerBehavior = _triggerSetting$trigg2 === void 0 ? {} : _triggerSetting$trigg2,
              triggerWay = triggerSetting.triggerWay;
            var _ref11 = triggerBehavior || {},
              _ref11$data = _ref11.data,
              behaviorData = _ref11$data === void 0 ? [] : _ref11$data;
            if (triggerBehavior.type != '1' || triggerWay != '2') {
              // 非行为方式
              return false;
            }
            behaviorData.forEach(function (dataListItem) {
              (dataListItem || []).forEach(function (item) {
                if ((item.range == 'all' || item.range == 'special' && checkMatchHref(item.rangeDetail)) && (item.action == 'daycount' || item.action == 'timecount')) {
                  // 满足全部页面或对应的指定页面是，记录下一个流程中处理缓存
                  behaviorFrequencyInfo.push({
                    action: item.action,
                    range: item.range,
                    rangeDetail: item.rangeDetail,
                    num: item.num,
                    operator: item.operator,
                    surveyId: survey.id
                  });
                }
              });
            });
          });
          analysisBehaviorFrequency(behaviorFrequencyInfo, pid).then(function () {
            resolve(true);
          });
        });
      } catch (error) {
        resolve(false);
      }
    });
  };

  // 监测到满意度配置更新时，更新问卷配置存储的时间，但是暂时不清除问卷其他对应本地缓存数据
  var setConfigVersion = function setConfigVersion() {
    var config = aes.getConfig() || {};
    var pid = config.plugin_survey && config.plugin_survey.pid || config.pid;
    return new Promise(function (resolve, reject) {
      Promise.all([getSchemaList(), _getStorage(XdomainStorageKeys.SurveyConfigVersions)]).then(function (_ref12) {
        var _ref13 = _slicedToArray(_ref12, 2),
          schemaList = _ref13[0],
          localConfigVersions = _ref13[1];
        var _loop = function _loop() {
          var schema = schemaList[index] || {};
          var id = schema.id,
            gmtModified = schema.gmtModified;
          var curLocalConfig = localConfigVersions === null || localConfigVersions === void 0 ? void 0 : localConfigVersions.find(function (item) {
            return (item === null || item === void 0 ? void 0 : item.id) === id;
          });

          /**
           * 用户访问时，记录线上配置版本
           * 当线上配置版本与本地配置版本不一致时 [重置用户行为]
           * 当本地无配置版本时，
           * 若线上配置时间 > 此次插件版本发布上线时间(当前版本 1.1.1) [重置用户行为]
           *
           * 否则 不做处理
           */
          // const publishTime = 1657709204932; // 版本 1.1.1 的发布时间
          // const shouldClearLocalBehavior = curLocalConfig
          //   ? curLocalConfig?.gmtModified !== gmtModified
          //   : new Date(gmtModified).getTime() > publishTime;

          // if (shouldClearLocalBehavior) {
          //   // 除版本信息外，其他本地缓存都移除
          //   const toBeCleanedKeys = Object.keys(XdomainStorageKeys)
          //     .map((key) => XdomainStorageKeys[key])
          //     .filter((key) => key !== XdomainStorageKeys.SurveyConfigVersions);

          //   Promise.all(
          //     toBeCleanedKeys.map((key) => _getStorage(key).then((data) => ({ key, data }))),
          //   ).then((localDatasList) => {
          //     localDatasList.forEach(({ key, data }) => {
          //       const cleanedLocalDatas = data?.filter((item) => {
          //         if (item?.surveyId) return item.surveyId !== id;
          //         return item?.id !== id;
          //       });
          //       _setStorage(key, cleanedLocalDatas);
          //     });
          //   });
          // }

          if (curLocalConfig) {
            curLocalConfig.gmtModified = gmtModified;
          } else {
            localConfigVersions === null || localConfigVersions === void 0 || localConfigVersions.push({
              id: id,
              gmtModified: gmtModified,
              pid: pid
            });
          }
        };
        for (var index = 0; index < schemaList.length; index++) {
          _loop();
        }

        // 版本更新写入本地
        _setStorage(XdomainStorageKeys.SurveyConfigVersions, localConfigVersions);
        resolve(true);
      });
    });
  };

  // 数据转存到indexDB
  var transferStorage = function transferStorage() {
    return new Promise(function (resolve, reject) {
      try {
        // 转存
        for (var key in XdomainStorageKeys) {
          var slist = JSON.parse(localStorage.getItem("aem-".concat(XdomainStorageKeys[key])) || '[]') || [];
          if (slist !== null && slist !== void 0 && slist.length) {
            localStorage.removeItem("aem-".concat(XdomainStorageKeys[key]));
            set("aem-".concat(XdomainStorageKeys[key]), JSON.stringify(slist));
          }
        }
        resolve();
      } catch (e) {
        console.error('[AES] plugin-survey', 'fail to transfer buffer into indexdb');
        reject();
      }
    });
  };
  var init = function init() {
    // return setConfigVersion().then(() => setBehaviorFrequency());
    return transferStorage().then(function () {
      setConfigVersion().then(function () {
        return setBehaviorFrequency();
      });
    });
  };
  var utils = {
    init: init,
    setFrequency: setFrequency,
    sendLog: sendLog,
    setLogicRules: setLogicRules,
    setRequireLogicRules: setRequireLogicRules,
    getStorage: _getStorage,
    setStorage: _setStorage
  };
  return {
    getSchema: getSchema,
    getDraftSchema: getDraftSchema,
    getSchemaList: getSchemaList,
    utils: utils
  };
}